import { initFirebase } from '../firebase'
import {
  collection,
  getDocs,
  query,
  orderBy,
  doc,
  getDoc
} from 'firebase/firestore'

const { db } = initFirebase()

/**
 * Thread-aware email service.
 * Reads from email_threads (one doc per conversation) and email_messages
 * (one doc per email, inbound or outbound).
 */
export class FirebaseEmailRepliesService {
  async listThreads() {
    const ref = collection(db, 'email_threads')
    const q = query(ref, orderBy('lastActivityAt', 'desc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async getThread(threadId) {
    if (!threadId) return null
    const ref = doc(db, 'email_threads', threadId)
    const snap = await getDoc(ref)
    if (!snap.exists()) return null
    return { id: snap.id, ...snap.data() }
  }

  async getMessagesForThread(threadId) {
    if (!threadId) return []
    // Subcollection: email_threads/{threadId}/messages
    const ref = collection(db, 'email_threads', threadId, 'messages')
    const q = query(ref, orderBy('createdAt', 'asc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async getThreadWithMessages(threadId) {
    const [thread, messages] = await Promise.all([
      this.getThread(threadId),
      this.getMessagesForThread(threadId)
    ])
    return { thread, messages }
  }
}
